import * as React from 'react';

import Navbar from "../../Layouts/Navbar";

import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {useNavigate, useParams} from "react-router-dom";
import 'react-slideshow-image/dist/styles.css'
import Header from "../../Layouts/Header";
import {HiOutlineQrcode} from "react-icons/hi";
import {BsCalendar4Week} from "react-icons/bs";

import Barcode from 'react-barcode';
export default function OrderDetails() {
    const navigate = useNavigate();
    const {id} = useParams();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [order, setOrder] = React.useState([]);
    const [details, setDetails] = React.useState([]);
    const [correct, setCorrect] = React.useState(0);
    const [error, setError] = React.useState(0);


    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }
        const params = {
            'processFor' : 'Sales',
            'returned' : 1
        }

        API.getOrder(params , id)
            .then((response) => {
                setOrder(response.data);

                API.getDetails( id)
                    .then((response) => {
                        setDetails(response.data);

                        let errorN = 0;
                        let correctN = 0;
                        response.data.forEach (bt => {

                            if(bt.status_id === 19 ) {
                                correctN++
                            }
                            else {
                                errorN++
                            }

                        })
                        setCorrect(correctN)
                        setError(errorN)
                        setIsLoaded(true);

                    })
            })
            .catch((error) => {

                if(error.response) {
                    toast.error(error.response.data.message);
                    setTimeout (() => {
                        window.history.back()
                    },400)
                }
                else {
                    toast.error(error.message);
                    setTimeout (() => {
                        window.history.back()
                    },400)
                }
            });

    }, [id]);

    const onStatusButtonClick =  (statusId) => {
        setIsLoaded(false);
        const request = {
            'order_id': id,
            'status_id' : statusId,
            'processFor' : 'Sales',
            'calc_battery_count' : 1
        }
        API.updateStatus( request )
            .then((response) => {
                toast.success(response.message);
                setTimeout(() => {
                    navigate('/returned-orders/');
                }, 2000);
            })
            .catch((error) => {
                toast.error(error.response.data.message)
                setIsLoaded(true);
            });
    }

    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header hasBack={true} title='NGKH'/>

            <section className="section mt-4 pt-5 rtl">
                <div className="row mx-2 pb-5 mb-5">
                    <div className="col-12">
                        <section className="section">
                            <div className="row">
                                <div className="col-lg-12">

                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-12 text-center text-muted text-small-1 fw-bold">
                                                    {order?.vendor?.title}
                                                    &nbsp;
                                                    (
                                                    {order?.vendor?.city}
                                                    )
                                                </div>
                                            </div>
                                            <div className="row mx-2 mb-3 border-bottom pb-2 pt-5">
                                                <div className="col-1">
                                                    <HiOutlineQrcode />
                                                </div>
                                                <div className="col-5 text-small-2">
                                                    کد رهگیری:
                                                </div>
                                                <div className="col-6 text-start fw-bold text-small-2">
                                                    {order.tracking_code}
                                                </div>
                                            </div>

                                            <div className="row mx-2 mb-3 pb-2 ">
                                                <div className="col-1">
                                                    <BsCalendar4Week />
                                                </div>
                                                <div className="col-4 text-small-2">
                                                    تاریخ ثبت
                                                </div>
                                                <div className="col-7 text-start fw-bold text-small-2">
                                                    {order.date}
                                                </div>
                                            </div>



                                        </div>
                                    </div>

                                </div>


                            </div>

                            <div className="row mt-4">
                                <div className="col-6 alert alert-success text-center text-small-2">
                                    تعداد باتری ثبت شده:
                                    <span className='fw-bold px-3 text-big-3'>
                                        {
                                            correct
                                        }
                                   </span>
                                </div>
                                <div className="col-6 alert alert-danger text-center text-small-2">
                                    تعداد باتری ثبت  نشده:
                                   <span className='fw-bold px-3 text-big-3'>
                                        {
                                            error
                                        }
                                   </span>
                                </div>
                                {
                                    details?.map(bt => {

                                        return (
                                            <div className="col-12  px-3 mt-3">
                                                <div className={
                                                    bt.status_id === 19 ? 'bg-white rounded ' : 'bg-secondary-subtle rounded '
                                                }

                                                >
                                                    <Barcode value={bt.code} height={20} width={1} fontSize={12}/>
                                                <span className='text-small-3 px-2  w-100'>
                                                        {
                                                            bt.brand
                                                        }
                                                    -
                                                    <span className='fw-bold px-2'>{
                                                        bt.status
                                                    }</span>
                                                    -
                                                    {
                                                        bt.properties[0].amperage
                                                    }
                                                    &nbsp;
                                                    آمپر
                                                </span>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>

                        </section>
                    </div>


                </div>
            </section>

        </React.Fragment>
    );
};
